export default __webpack_public_path__ + "static/media/landing-credit-lift.0906e727.webp";